import type { Example } from "../types";
import code from "./code.js" with { type: "text" };
import golden from "./golden.json";

export const benignWidget: Example = {
  id: "benign-widget",
  title: "Benign widget",
  group: "baseline",
  environment: "browser",
  mode: "script",
  summary: "A review badge from a first-party API: a quiet baseline",
  explainer:
    "For contrast: one first-party request (answered by a mock route) and one badge added to the page. No storage, no probing, no fingerprinting, no third parties.",
  code,
  context: {
    mockRoutes: [
      {
        url: "https://shop.example/api/reviews/summary",
        headers: { "content-type": "application/json" },
        body: '{"rating":4.8,"count":212}',
      },
    ],
  },
  expect: golden as Example["expect"],
};
